import React from 'react';
import { Row, Col } from 'react-bootstrap';

const PickupsRow = () => {
  return (
    <Row className="g-0 h-100 px-4 mb-2 align-content-center d-none d-lg-flex align-items-center custom-sort">
      <Col md="2" className="d-flex flex-column mb-lg-0 pe-3">
        <div className="text-muted text-small cursor-pointer">ID RECOLECCIÓN</div>
      </Col>
      <Col md="2" className="d-flex flex-column pe-1 justify-content-center align-items-start bg-infow">
        <div className="text-muted text-small cursor-pointeR">FECHA</div>
      </Col>
      <Col md="2" className="d-flex flex-column ps-4 pe-1 justify-content-center align-items-center bg-successw">
        <div className="text-muted text-small cursor-pointeR">PAQUETES</div>
      </Col>
      <Col md="1" className="d-flex flex-column pe-1 justify-content-center align-items-start">
        <div className="text-muted text-small cursor-pointer">PESO TOTAL</div>
      </Col>
      <Col md="3" className="d-flex flex-column pe-1 justify-content-center align-items-end">
        <div className="text-muted text-small cursor-pointer">CIUDAD</div>
      </Col>
      <Col md="2" className="d-flex flex-column pe-1 justify-content-center align-items-end">
        <div className="text-muted text-small cursor-pointer">CP</div>
      </Col>
    </Row>
  );
};

export default PickupsRow;
